import { applyHeroVideoPoster, applyHeroVideoSource, HERO_VIDEO_MOBILE_MEDIA, } from "@/utils/hero-video.util";
/**
 * Custom video play/pause control (no native controls).
 * Also assigns desktop vs mobile src — browsers ignore media on <source> inside <video>.
 */
export const VideoCustomControls = (element) => {
    const video = element.querySelector("video");
    const button = element.querySelector("[data-hero-video-toggle]");
    if (!video) {
        return;
    }
    const isLazy = video.classList.contains("preview");
    const apply = () => {
        applyHeroVideoPoster(video, element);
        if (isLazy) {
            return;
        }
        if (applyHeroVideoSource(video)) {
            void video.play().catch(() => { });
        }
    };
    apply();
    const mediaQuery = window.matchMedia(HERO_VIDEO_MOBILE_MEDIA);
    mediaQuery.addEventListener("change", apply);
    if (!button) {
        return () => {
            mediaQuery.removeEventListener("change", apply);
        };
    }
    const playIcon = button.querySelector("[data-icon-play]");
    const pauseIcon = button.querySelector("[data-icon-pause]");
    const syncUi = () => {
        const paused = video.paused;
        playIcon?.classList.toggle("hidden", !paused);
        pauseIcon?.classList.toggle("hidden", paused);
        button.setAttribute("aria-label", paused ? "Play" : "Pause");
    };
    const toggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (video.paused) {
            void video.play().catch(() => { });
        }
        else {
            video.pause();
        }
    };
    button.addEventListener("click", toggle, true);
    video.addEventListener("play", syncUi);
    video.addEventListener("pause", syncUi);
    syncUi();
    return () => {
        mediaQuery.removeEventListener("change", apply);
        button.removeEventListener("click", toggle, true);
        video.removeEventListener("play", syncUi);
        video.removeEventListener("pause", syncUi);
    };
};
